export const ClientBrowsingHistoriesEmpty = {
    clientBrowsingHistoriesForClientMain: "閲覧機歴がありません。",
    clientBrowsingHistoriesForClientDescription: "閲覧したプロが表示されます。",
};


// WEBPACK FOOTER //
// ./src/config/view_const/client_browsing_histories.ts